import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Typography } from '@material-ui/core';
import useWindowDimensions from '../hooks/useWindowDimensions';
import { closeTaskStyles } from '../constants';
import { openTaskChatDialog } from './redux';
import ChatBadge from './ChatBadge';
import { withChatBoundary } from './ChatErrorBoundary';
import { chatIndicator, chatUnreadCount } from './chatState';

const TaskChatButton = ({ task }) => {
  const dispatch = useDispatch();
  const enabled = useSelector(state => state.chat.enabled);
  const { fontSize } = useWindowDimensions();
  const isTaskChat = x => !!task && x.scheduleTaskId === Number(task.id);
  const indicator = useSelector(state => chatIndicator(state.chat, isTaskChat));
  const count = useSelector(state => chatUnreadCount(state.chat, isTaskChat));

  if (!enabled || !task) return null;

  return (
    <ChatBadge style={closeTaskStyles.margin} indicator={indicator} count={count}>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => dispatch(openTaskChatDialog(task))}
      >
        <Typography component="span" style={fontSize}>
          Чат с координатор
        </Typography>
      </Button>
    </ChatBadge>
  );
};

export default withChatBoundary(TaskChatButton);
